import { safeStorage } from './safe-storage';
import type { Theme } from './types';

const STORAGE_KEY = 'theme';

function isTheme(v: unknown): v is Theme {
  return v === 'dark' || v === 'light';
}

export function resolveInitialTheme(): Theme {
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get('theme');
  if (isTheme(fromQuery)) return fromQuery;
  const stored = safeStorage.get(STORAGE_KEY);
  if (isTheme(stored)) return stored;
  if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) return 'dark';
  return 'light';
}

export function applyTheme(next: Theme): void {
  if (!isTheme(next)) return;
  document.documentElement.setAttribute('data-theme', next);
  safeStorage.set(STORAGE_KEY, next);
}

export function onThemeMessage(handler: (next: Theme) => void): () => void {
  const listener = (e: MessageEvent) => {
    const data = e.data as unknown;
    if (!data || typeof data !== 'object') return;
    const obj = data as { type?: unknown; value?: unknown };
    if (obj.type !== 'theme') return;
    if (!isTheme(obj.value)) return;
    handler(obj.value);
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}
